<template>
    <v-layout row wrap>
      <template v-if="isOnGoingOrUpcomingEvents">
        <v-flex v-if="ongoingList.data && ongoingList.data.length" xs12 class="my-4 py-4">
          <div
          :class="[
              'custom_heading primary--text mb-3',
              $vuetify.breakpoint.width < 959 ? 'text-xs-center' : null,
          ]"
          >
              <span class="underline">{{ $t("screening.ongoing.title") }}</span>
          </div>
          <ScreenerList :list="ongoingList.data"> </ScreenerList>
          <v-layout align-center justify-center class="mb-2 mt-5">
              <v-btn
                  color="primary background--text"
                  @click="$router.push({ name: 'screeners.ongoing' })"
                  >{{ $t("screening.ongoing.see_more_btn") }}</v-btn
              >
          </v-layout>
          <v-divider class="mt-5" />
        </v-flex>
        <v-flex v-if="upcomingList.data && upcomingList.data.length" class="my-4 py-4" xs12>
          <div
          :class="[
              'custom_heading primary--text mb-3',
              $vuetify.breakpoint.width < 959 ? 'text-xs-center' : null,
          ]"
          >
            <span class="underline"> {{ $t("screening.upcoming.title") }}</span>
          </div>
          <ScreenerList :list="upcomingList.data"> </ScreenerList>
          <v-layout align-center justify-center class="mb-2 mt-5">
            <v-btn
                color="primary background--text"
                @click="$router.push({ name: 'screeners.upcoming' })"
                >{{ $t("screening.upcoming.see_more_btn") }}</v-btn
            >
          </v-layout>
          <v-divider class="mt-5" />
        </v-flex>
      </template>
      <!-- <v-layout class="py-5" v-else justify-center align-center wrap>
        <div
          :class="[
          'custom_heading',
          'primary--text',
          'text-xs-center',
          ]"
      >{{$t('screening.no_ongoing_upcoming_events.title')}}.
      </div>
      </v-layout> -->
      <v-flex v-if="vodList.data && vodList.data.length" xs12 class="my-4 py-4">
        <div
            :class="[
            'custom_heading primary--text mb-3',
            $vuetify.breakpoint.width < 959 ? 'text-xs-center' : null,
            ]"
        >
            <span class="underline">{{ $t("screening.vod.title") }}</span>
        </div>
        <ScreenerList :list="vodList.data" :is_vod="true"> </ScreenerList>
        <v-layout align-center justify-center class="mb-2 mt-5">
            <v-btn
            color="primary background--text"
            @click="$router.push({ name: 'vod.movies' })"
            > <span class="underline">{{ $t("screening.vod.see_more_btn") }}</span></v-btn
            >
        </v-layout>
        <v-divider class="mt-5" />
      </v-flex>
      <v-flex v-if="archiveList.data && archiveList.data.length" class="my-4 py-4" xs12>
        <div
            :class="[
            'custom_heading primary--text mb-3',
            $vuetify.breakpoint.width < 959 ? 'text-xs-center' : null,
            ]"
        >
            <span class="underline">{{ $t("screening.past_events.title") }}</span>
        </div>
        <ScreenerList :list="archiveList.data" :is_past="true"> </ScreenerList>
        <v-layout align-center justify-center class="mb-2 mt-5">
            <v-btn
            class="mt-4"
            color="primary background--text"
            @click="$router.push({ name: 'screeners.archive' })"
            >{{ $t("screening.past_events.see_more_btn") }}</v-btn
            >
        </v-layout>
      </v-flex>
    </v-layout>
</template>

<script>
import { mapState } from "vuex";
import ScreenerList from "@/components/home/ScreenerList";

export default {
    name: "Dashboard",
    components: {
        ScreenerList,
    },
    computed: {
    ...mapState({
      upcomingList: (state) => state.screening.upcomingList,
      ongoingList: (state) => state.screening.ongoingList,
      archiveList: (state) => state.screening.archiveList,
      vodList: (state) => state.screening.vodList,
    }),
    isOnGoingOrUpcomingEvents(){
        return (this.ongoingList.data && this.ongoingList.data.length)||(this.upcomingList.data && this.upcomingList.data.length)
    }
  },
  created() {
    this.getApiData();
  },
  methods: {
    async getApiData() {
      try {
        this.$store.dispatch("screening/upcomingList",{
          page: 1,
          perPage: 8,
        });
        this.$store.dispatch("screening/ongoingList",{
          page: 1,
          perPage: 8,
        });
        this.$store.dispatch("screening/listVodEvents",{
          page: 1,
          perPage: 8,
        });
        this.$store.dispatch("screening/archiveList", {
          page: 1,
          perPage: 8,
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
  },
}
</script>

<style scoped>
.text-align {
  text-align: justify;
}
.grey.lighten-5 {
  border: 1px solid var(--v-primary-base) !important;
  border-radius: 5px !important;
}
.custom-card-text {
  min-height: 35vmin;
  font-size: 5vh;
}
.custom_heading {
  font-size: 4vh;
}
.underline {
  border-bottom: 2px solid var(--v-primary-base);
}
</style>
